import { Component, inject } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-smallest-capacity-modal',
  imports: [MatDialogModule],
  templateUrl: './smallest-capacity-modal.html',
})
export class SmallestCapacityModal {
  dialog = inject(MatDialog);

  closeDialog(): void {
    this.dialog.closeAll();
  }
}
